import { breakpointVal, iconOrderBefore, IconSvg } from '@graphcommerce/next-ui'
import { Box, darken, lighten } from '@mui/material'
import { UseAddProductsToCartActionFragment } from '@graphcommerce/magento-product/components/AddProductsToCart/UseAddProductsToCartAction.gql'
import { Trans } from "@lingui/react";
import { i18n } from '@lingui/core'
import { Link } from '@mui/material'

type ProductSidebarDeliveryProps = {
  product?: UseAddProductsToCartActionFragment
  externalSource?: number | null
}

export function ProductSidebarDelivery(props: ProductSidebarDeliveryProps) {
  const { product, externalSource } = props
  const { stock_status, only_x_left_in_stock } = product ?? {}

  let title = externalSource === 1 ? i18n._(/* i18n */ 'In Stock - External warehouse') : i18n._(/* i18n */ 'In Stock')
  let subtitle: JSX.Element | string = <Link href='/service/shipping' color='textPrimary' underline='always'>
    <Trans id={externalSource === 1 ? 'One-week delivery - Shipping free' : 'Next day delivery - Shipping free'} />
  </Link>

  if (stock_status === 'OUT_OF_STOCK') {
    title =  i18n._(/* i18n */'Out of stock')
    subtitle =  i18n._(/* i18n */'We are sorry, this product is currently out of stock.')
  } else if (stock_status === 'IN_STOCK' && only_x_left_in_stock) {
    title =  i18n._(/* i18n */'Only a few left')
    subtitle =  i18n._(/* i18n */`Only ${only_x_left_in_stock} left in stock.`)
  }
  if (only_x_left_in_stock === 1) {
    subtitle =  i18n._(/* i18n */'Only 1 left in stock.')
  }

  return (
    <Box
      sx={(theme) => ({
        display: 'grid',
        alignItems: 'center',
        gridTemplate: `
          "image title"
          ".     subtitle"
        `,
        gridTemplateColumns: `min-content auto`,
        columnGap: theme.spacings.xxs,
        background:
          theme.palette.mode === 'light'
            ? darken(theme.palette.background.default, 0.01)
            : lighten(theme.palette.background.default, 0.2),
        padding: theme.spacings.xxs,
        ...breakpointVal(
          'borderRadius',
          theme.shape.borderRadius * 3,
          theme.shape.borderRadius * 4,
          theme.breakpoints.values,
        ),
      })}
    >
      <IconSvg src={iconOrderBefore} size='small' sx={{ gridArea: 'image' }} />
      <Box sx={{ typography: 'body2', gridArea: 'title', fontWeight: 600 }}>{title}</Box>
      <Box sx={{ typography: 'body2', gridArea: 'subtitle', color: 'text.primary' }}>
        {subtitle}
      </Box>
    </Box>
  )
}
